<template>
  <div class="qualify">
    <div class="qualifylist">
      <div class="qualifysingle" v-for="(i, j) in qualifylist" :key="j">
        <div class="imgbg">
          <img
            class="qimg"
            :src="i.url"
            alt=""
            @click="previewimg(i.url, i.title)"
          />
        </div>
        <div class="qname">{{ i.title }}</div>
      </div>
    </div>
    <el-dialog :title="showname" :visible.sync="showimg" width="41.67%">
      <div class="previewcon">
        <img style="width: 17.71vw; height: auto" :src="imgurl" alt="" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      qualifylist: [],
      showimg: false,
      imgurl: "",
      showname: "",
    };
  },
  mounted() {
    this.getlist();
  },
  methods: {
    async getlist() {
      let data = {
        category: "企业概况/企业资质",
      };
      let res = await this.$http.plist(data);
      if (res.code == 200) {
        this.qualifylist = res.data;
      }
    },
    previewimg(e, v) {
      this.showimg = true;
      this.imgurl = e;
      this.showname = v;
    },
  },
};
</script>

<style scoped lang="less">
.previewcon {
  width: 100%;
  height: 27.24vw;
  background: rgba(247, 249, 252, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.qualify {
  .qualifylist {
    .qualifysingle {
      .qname {
        font-size: 0.83vw;
        text-align: center;
        color: #06192d;
        overflow: ellipse;
        margin-top: 1.3vw;
      }
      .imgbg {
        .qimg {
          width: 8.44vw;
          height: 11.67vw;
        }
        width: 13.13vw;
        height: 13.13vw;
        background: #f7f9fc;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      width: 15.63vw;
      height: 18.44vw;
      background: #fff;
      padding: 1.25vw;
    }
    .qualifysingle:hover {
      margin-top: -0.52vw;
      border-bottom: 0.21vw solid #1961ac !important;
    }
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 2.08vw;
  }
  width: 61.25vw;
  background: url("../assets/image/qualifybg.png") no-repeat;
  background-position: 0 0;
  background-size: 100% 100%;
  padding: 1.56vw 5.1vw 2.6vw 5.1vw;
}
::v-deep .el-dialog__header {
  background: rgba(209, 223, 238, 0.7);
  text-align: center;
  padding: 1.04vw 0;
  height: 4.17vw;
  line-height: 2.08vw;
}
::v-deep .el-icon-close {
  font-size: 1.88vw !important;
  color: rgba(0, 0, 0, 0.6) !important;
  line-height: 1.88vw;
}
::v-deep .el-dialog__headerbtn {
  top: 1.15vw;
}
</style>
